export default __webpack_public_path__ + "static/media/photo--sm--rambo-1.2dd98c0d.jpg";